if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.quantityInput = this.querySelector('.quantity__input');
        this.configuratorTrigger = this.querySelector('[data-configurator]');
        this.variantsData;
        this.updateMediaGrouping();
        
        // this.productTags = JSON.parse(this.dataset.tags);
        // if (this.dataset.discounts) {
        //     this.discounts = JSON.parse(this.dataset.discounts);
        // }
        if (this.configuratorTrigger) {
            this.productConfigurator = document.querySelector('product-configurator[data-section="' + this.configuratorTrigger.dataset.configurator + '"]');
            const params = (new URL(document.location)).searchParams;
            if (params.has('_configurator_design_id')) {
                this.productConfigurator.dispatchEvent(new CustomEvent('shirtup:render', { bubbles: true }));
            }
        }

        if (this.configuratorTrigger && this.productConfigurator) {
          this.configuratorTrigger.addEventListener('click', (ev) => {
              ev.preventDefault();
              this.productConfigurator.dispatchEvent(new CustomEvent('shirtup:render', { bubbles: true }));
          });
      }
        
      }

           connectedCallback() {
          this.initializeProductSwapUtility();
      
          // Bind checkbox change handlers
          this.handleSizeCheckboxChanges();

          //bulk discount
          this.updateBulkDiscount('dtf')

         // handlePrintTypeChange
          this.handlePrintTypeChange();        
          this.addEventListener('change', ()=>{
           this.handlePrintTypeChange();
          })
      
          // Send initial sizes on load
          this.sendPreselectedSizesOnly();
      
          // Additional initialization
          const variant = this.getSelectedVariant(document);
      
          this.onVariantChangeUnsubscriber = subscribe(
              PUB_SUB_EVENTS.optionValueSelectionChange,
              this.handleOptionValueChange.bind(this)
          );
      
          this.initQuantityHandlers();
          this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      updateBulkDiscount(technique) {  
   var BULK_DISCOUNTS = [];

        if(Shopify.locale == "es") {
          BULK_DISCOUNTS = [
            {
              name: "tshirts",
              tag: "TAG-A",
              breaks: [
              { quantityRange: "2-2", percentage: 10 },
              { quantityRange: "3-4", percentage: 25 },
              { quantityRange: "5+", percentage: 30 },
              ]
            }
          ];   
        } else { 
          BULK_DISCOUNTS = [
            {
              name: "tshirts",
              tag: "TAG-A",
              breaks: [
            { quantityRange: "5-9", percentage: 5 },
            { quantityRange: "10-19", percentage: 15 },
            { quantityRange: "20-49", percentage: 25 },
            { quantityRange: "50-99", percentage: 35 },
            { quantityRange: "100-349", percentage: 45 },
            { quantityRange: "350+", percentage: 50 },
              ]
            }
          ];    
        }
    const bulkDiscountElement = document.querySelector('.bulk-discount-accordion');
    let percentage = bulkDiscountElement.dataset.percentage;


    if(parseInt(percentage) != 0) {
      let BULK_DISCOUNTS2 = JSON.parse(bulkDiscountElement.dataset.discounts);
      let productTags = bulkDiscountElement.dataset.tags;
      let copyDiscountGroup;
      let newBreaks;

      
  
      BULK_DISCOUNTS2.forEach(discountGroup => {
        copyDiscountGroup = { ...discountGroup };
        
        
        if (productTags.includes(discountGroup.tag)) {
          
          newBreaks = discountGroup.breaks.filter(breakItem => breakItem.percentage > percentage);
          
          
          if (percentage !== 0 && (!newBreaks.length || newBreaks[0].percentage !== percentage)) {
              newBreaks.unshift({
                  quantity: 1,
                  percentage: parseInt(percentage),
                  message: `Quantity discount for ${percentage}% off`,
              });
          }

          copyDiscountGroup.breaks = newBreaks;
        }
      })

      
      
      BULK_DISCOUNTS = [
        {
          name: copyDiscountGroup.name,
          tag: copyDiscountGroup.tag,
          breaks: copyDiscountGroup.breaks.map((item, index, arr) => {
            const nextQuantity = arr[index + 1]?.quantity;
            
            const quantityRange = nextQuantity 
              ? `${item.quantity}-${nextQuantity - 1}` 
              : `${item.quantity}+`;
            
            return {
              quantityRange,
              percentage: item.percentage
            };
          })
        }
      ];

    }

    


    let rangeInput = document.querySelector('.js-dotted-range-slider');
    let dotsContainer = document.querySelector('.range-slider__dots');
    let discountPercentageElement = document.querySelector('.discount-percentage');
    let discountedPriceElement = document.getElementById('discounted-price');    
  
    const bulkDiscounts = BULK_DISCOUNTS[0].breaks;
    let isPredesign = false;
    let basePrice = 0;
    let printPrice;
    let basePricePredesign = 0;
    let currency = "€";
    let off = "Off";
    
    // const bulkDiscountElement = document.querySelector('.bulk-discount-accordion');
    
    
    if (bulkDiscountElement) {
      isPredesign = bulkDiscountElement.dataset.predesign == "true" ? true : false;
      basePrice = parseFloat(bulkDiscountElement.dataset.price || "0");
      const dtfOnePrintPrice = bulkDiscountElement.dataset.dtfOnePrintPrice;
      const dtgOnePrintPrice = bulkDiscountElement.dataset.dtgOnePrintPrice;
      let parentSpan = document.querySelector('.one_print_area');
      
      basePrice = (Number(basePrice) / 100).toFixed(2);
      if(technique == 'dtg') {
        if(parentSpan){ 
          parentSpan.innerHTML = `${dtgOnePrintPrice} <span class="body-medium-bold" id="discounted-price-print">-</span>`;        
        }
        printPrice = Number(bulkDiscountElement.dataset.price) + Number(bulkDiscountElement.dataset.basicPrint);  
      }else if (technique == 'dtf') {
        if(parentSpan) {
          parentSpan.innerHTML = `${dtfOnePrintPrice} <span class="body-medium-bold" id="discounted-price-print">-</span>`;        
        }
        printPrice = Number(bulkDiscountElement.dataset.price) + Number(bulkDiscountElement.dataset.print);
      }
          
      printPrice = (printPrice / 100).toFixed(2);
      
      const predeisgnPrice = document.querySelector('.js-predesign-price');      
      basePricePredesign = (Number(predeisgnPrice.dataset.price) / 100).toFixed(2);            
      currency = bulkDiscountElement.dataset.currency || "€";
      off = bulkDiscountElement.dataset.off || "Off";
    }
  
    const maxRange = bulkDiscounts.length - 1;
    rangeInput.setAttribute('max', maxRange);
  
    dotsContainer.innerHTML = ''; // Clear existing dots
    bulkDiscounts.forEach((discount, index) => {
      const dot = document.createElement('span');
      dot.className = 'range-slider__dot';    
      dotsContainer.appendChild(dot);
    });
  
  function applyColors(elements, colors) {
    if (elements.length === 1) {
      elements[0].style.background = `linear-gradient(to right, ${colors[0]}, ${colors[2]})`;
    } else if (elements.length === 2) {
      elements[0].style.background = colors[0];
      elements[1].style.background = colors[2];
    } else {
      const total = elements.length;
      const part = Math.floor(total / 3);
  
      for (let i = 0; i < part; i++) {
        elements[i].style.background = colors[0];
      }
      for (let i = part; i < part * 2; i++) {
        elements[i].style.background = colors[1];
      }
      for (let i = part * 2; i < total; i++) {
        elements[i].style.background = colors[2];
      }
  
      const remainder = total % 3;
      if (remainder === 1) {
        elements[part].style.background = colors[1];
      } else if (remainder === 2) {
        elements[part].style.background = colors[1];
        elements[part + 1].style.background = colors[1];
      }
    }
  }
  
  const dots = document.querySelectorAll('.range-slider__dot');
  const colors = ['#4999A7', '#6B79A7', '#D1919E'];
  
  applyColors(dots, colors);
    
  const updateUI = (value) => {
    const discount = bulkDiscounts[value];
    if (!discount) return;

    const discountPercentage = discount.percentage;
    let discountedPrintPriceElement = document.getElementById('discounted-price-print');    
    
    if(discountPercentageElement) {
    discountPercentageElement.textContent = `${discountPercentage}% ${off}`;
    }

    if (isPredesign && basePricePredesign > 0 && discountedPriceElement) {
      const discountedPrice = basePricePredesign * (1 - discountPercentage / 100);      
      if(Shopify.country == "NL"){
        discountedPriceElement.textContent = `${currency} ${discountedPrice.toFixed(2)}`;
      } else {
        discountedPriceElement.textContent = `${discountedPrice.toFixed(2)} ${currency}`;
      }
    } else {
      const discountedPricePrint = basePrice * (1 - discountPercentage / 100);
      const discountedPriceItem = printPrice * (1 - discountPercentage / 100);
      discountedPriceElement.textContent = `${discountPercentage}%`;
      discountedPriceElement.style.color = "var(--text-warning)";
      if(Shopify.country == "NL"){         
        discountedPrintPriceElement.textContent = `${currency} ${discountedPriceItem.toFixed(2)}`;
      } else {        
        discountedPrintPriceElement.textContent = `${discountedPriceItem.toFixed(2)} ${currency}`;
      }
    }
  };
  
    updateUI(rangeInput.value);
  
    rangeInput.addEventListener('input', () => {
      updateUI(rangeInput.value);
    });  
  }

       handlePrintTypeChange() {
         const pdpTabsEl = document.querySelector('pdp-tabs');

        if (pdpTabsEl) {
          pdpTabsEl.dispatchEvent(new Event('trigger-technique-change'));
        }
         
        let radioBtn = this.querySelector('.radio-btn:checked');
          
      if(radioBtn) {
        let printTechniqueSelected = this.querySelector('.radio-btn:checked').value;

        if(printTechniqueSelected == 'DTG') {
          this.updateBulkDiscount('dtg')
        } else if (printTechniqueSelected == 'DTF') {
          this.updateBulkDiscount('dtf')
        }
        
        const event = new CustomEvent('shirtup:updatePrintTechnique', {
          bubbles: true,
          detail: {
              selectedTechnique: printTechniqueSelected
          },
        });
        
        if (this.productConfigurator) {
          this.productConfigurator.dispatchEvent(event);
        } else {
          console.error('Product configurator not found.');
        }

        let colorPickerElement = document.querySelector('.colorEN:checked');
        if(colorPickerElement) {
          let hideDtgButton = colorPickerElement.dataset.dtg;
          let inputPrintType = this.querySelectorAll('input[data-print'); 
          
          if(hideDtgButton == 'true') {               
             if(inputPrintType) {
               inputPrintType.forEach(input => {
                 const inputId = input.id;
                 const escapedId = CSS.escape(inputId);
                 const label = document.querySelector(`label[for="${escapedId}"]`);
                  
                 if(input.dataset.print == "dtg") {                                           
                   label.classList.add('label__disabled');
                   input.checked = false;
                 } else {
                   label.classList.remove('label__disabled');                      
                   input.checked = true;
                 }
               })
             }
          } else {              
             if(inputPrintType) {
               inputPrintType.forEach(input => {
                 const inputId = input.id;
                 const escapedId = CSS.escape(inputId);
                 const label = document.querySelector(`label[for="${escapedId}"]`);                   
                  
                 label.classList.remove('label__disabled');                                         
               })
             }
          }
        } 
      }            
    }
      
      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      logCartQuantitiesForAllVariants() {
        const cartItems = window.CartItems || []; // Replace with your actual cart items structure

        // cartItems.forEach((item) => {
        //   console.log(`Variant ID: ${item.variant_id}, Quantity in Cart: ${item.quantity}`);
        // });
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;
        this.resetProductFormState();
         if (target.type === 'checkbox') {
           const label = target.parentElement; 
                if (target.checked) {
                    label.classList.add('active');
                }
                    
                   this.handleSizeCheckboxChanges();
                   this.sendPreselectedSizesOnly();
                    return; 
        }
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
        
        const variantId = target.getAttribute('data-variant-id');
        let variantHidden = target.getAttribute('data-variant-hidden');        
        if(variantHidden == null) {
          variantHidden = "false";
        }

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, variantId, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl,variantHidden),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }
      
      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }
          getCheckedSizes() {
            const checkedValues = [];
            // Ensure correct selector matches checkboxes
            this.querySelectorAll('.product-checkbox-1').forEach((checkbox) => {
                if (checkbox.checked) {
                    checkedValues.push(checkbox.value);
                }
            });
            return checkedValues;
        }

          sendPreselectedSizesOnly() {
          const preselectedSizes = this.getCheckedSizes(); // Use the scoped method
      
          const event = new CustomEvent('shirtup:updateSizes', {
              bubbles: true,
              detail: {
                  preselectedSizes: preselectedSizes,
              },
          });
      
          // Dispatch the event
          if (this.productConfigurator) {
              this.productConfigurator.dispatchEvent(event);
          } else {
              console.error('Product configurator not found.');
          }
      }
        handleSizeCheckboxChanges() {
        this.querySelectorAll('.product-checkbox-1').forEach((checkbox) => {
            checkbox.addEventListener('click', () => {
                const label = checkbox.parentElement; // Assuming the label wraps the input
                if (checkbox.checked) {
                    label.classList.add('active');
                } else {
                    label.classList.remove('active');
                }
    
                // Send only the sizes when a checkbox changes
                this.sendPreselectedSizesOnly();
            });
        });
    }


      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;


        const variantsColor = JSON.parse(selectedVariant);
        const color = variantsColor.option1;
        const size = [variantsColor.option2];
        

        const variants = this.getVariantData().filter(v => color == v['option1'] && v['available'] == true);
            const event = new CustomEvent('shirtup:update',
            {
                bubbles: true,
                detail: {
                    color: color,
                    variants: variants,
                    //preselectedVariants: size,
                }
            });
            if (this.configuratorTrigger) {
                this.productConfigurator.dispatchEvent(event);
            }
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`variant=${optionValues}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl,variantHidden) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
          
          const startDesignButton = this.querySelector('.g-btn__pdp');
          if (variantHidden == "false") {
            startDesignButton.removeAttribute('disabled');
          } else {
            startDesignButton.setAttribute('disabled', 'disabled');
          }

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);
          this.updateMediaGrouping();

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }
updateMediaGrouping() {
  const mediaGalleries = this.querySelectorAll('media-gallery');
  mediaGalleries.forEach(mediaGallery => {
    const groupVariants = mediaGallery.getAttribute('data-group-variants');
    const hasOnlyDefaultVariant = mediaGallery.getAttribute('data-has-only-default-variant');
    const disableImageGrouping = mediaGallery.getAttribute('data-disable-image-grouping');

    if (groupVariants === 'false' || hasOnlyDefaultVariant === 'true' || disableImageGrouping === 'true') {
      return;
    }

    const mediaItems = mediaGallery.querySelectorAll('.product__media-item, .thumbnail-list__item');
    const featuredMedia = Array.from(mediaItems).find(media => !media.classList.contains('hide-image'));
    const featuredVariantGrouping = featuredMedia ? featuredMedia.getAttribute('data-variant-grouping') : null;

    mediaItems.forEach(mediaItem => {
      const mediaVariantGrouping = mediaItem.getAttribute('data-variant-grouping');
      if (mediaVariantGrouping === featuredVariantGrouping) {
        mediaItem.classList.remove('hide-image');
      } else {
        mediaItem.classList.add('hide-image');
      }
    });

    const modalContent = this.productModal?.querySelector('.product-media-modal__content');
    if (modalContent) {
      modalContent.querySelectorAll('.product-modal-image').forEach(mediaItem => {
        const mediaVariantGrouping = mediaItem.getAttribute('data-variant-grouping');
        mediaItem.classList.toggle('hide-image', mediaVariantGrouping !== featuredVariantGrouping);
      });
    }
  });
}




      // updateMediaGrouping() {
      //   const mediaGalleries = this.querySelectorAll('media-gallery');
      //   console.log({mediaGalleries})

      //   mediaGalleries.forEach(mediaGallery => {
      //     console.log({mediaGallery})
          
      //     const groupVariants = mediaGallery.getAttribute('data-group-variants');
      //     console.log('groupvar', groupVariants)
      //     const hasOnlyDefaultVariant = mediaGallery.getAttribute('data-has-only-default-variant');
      //     const disableImageGrouping = mediaGallery.getAttribute('data-disable-image-grouping');
      
      //     if (groupVariants === 'false' || hasOnlyDefaultVariant === 'true' || disableImageGrouping === 'true') {
      //       return;
      //     }
      
      //     const mediaItems = mediaGallery.querySelectorAll('.product__media-item, .thumbnail-list__item');
      //     const featuredMedia = Array.from(mediaItems).find(media => !media.classList.contains('hide-image'));

      //     console.log('featuredMedia', featuredMedia)
      //     const featuredVariantGrouping = featuredMedia ? featuredMedia.getAttribute('data-variant-grouping') : null;
      //     console.log('mediaItems', mediaItems.length)
        
      //     console.log('featuredVariantGrouping', featuredVariantGrouping)
          
      //     mediaItems.forEach(mediaItem => {
      //       const mediaVariantGrouping = mediaItem.getAttribute('data-variant-grouping');
      //       console.log('mediaVarGr',mediaVariantGrouping)
      //       if (mediaVariantGrouping == featuredVariantGrouping) {          
      //         mediaItem.classList.remove('hide-image');
      //       } else {
      //         mediaItem.classList.add('hide-image');
      //       }
      //     });
      
      //     const modalContent = this.productModal?.querySelector('.product-media-modal__content');
      //     if (modalContent) {
      //       modalContent.querySelectorAll('.product-modal-image').forEach(mediaItem => {
      //         const mediaVariantGrouping = mediaItem.getAttribute('data-variant-grouping');
      //         mediaItem.classList.toggle('hide-image', mediaVariantGrouping !== featuredVariantGrouping);
      //       });
      //     }
      //   });
      // }
      


      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        this.fetchCart().then(cartData => {
          let totalCartQuantity = 0;
          const currentProductId = this.dataset.productId; 
        
          // Filter and sum up quantities for items with the same product ID
          cartData.items.forEach(item => {
            if (item.product_id === parseInt(currentProductId, 10)) {
              totalCartQuantity += item.quantity;
            }
          });
        
          window.totalCartQuantity = parseInt(totalCartQuantity || 0);
        
        
        }).catch(error => {
          console.error('Error fetching cart:', error);
        });
        
        
        
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchCart() {
        return fetch('/cart.js')
          .then(response => response.json())
          .then(cartData => cartData)
          .catch(error => {
            console.error('Error fetching cart:', error);
            throw error;
          });
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
      
      getVariantData() {
        this.variantsData =  JSON.parse(this.querySelector('#allVariants').textContent);
        return this.variantsData;
    }
      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}